import React from 'react';
import { templateLibrary } from '../data/resources';
import { templateSamples } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
import { BonusOfferTag } from './BonusOfferTag';
export function TemplateLibrary() {
  return <section aria-labelledby="library-title" className="on-dark bg-teal text-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-196" data-mp="1cgsvm2rjxwfp">
      <div className="max-w-6xl mx-auto" data-id="element-197" data-mp="1hfm9hwar3pge">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-198" data-mp="jv9gha3twcvg">
          <div className="lg:col-span-6" data-id="element-199" data-mp="ot1gysijh7b9">
            <div className="rounded-[2rem] overflow-hidden aspect-square ring-1 ring-gold/40" data-id="element-200" data-mp="ott2tbmc3qoc">
              <img src={templateLibrary.image} alt={templateLibrary.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-201" data-mp="tqtafqyu11hk" />
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-202" data-mp="12nqv7jilijb">
            <p className="font-serif text-lg font-semibold text-coral-light" data-id="element-203" data-mp="11macnjqc3u7">Bonus 5</p>
            <div className="mt-3" data-id="element-204" data-mp="60yvn3uyd2uo">
              <BonusOfferTag referencePrice={templateLibrary.referencePrice} onDark data-id="element-205" data-mp="2q670ewdoq6wr" />
            </div>
            <h2 id="library-title" className="mt-5 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-206" data-mp="2l7nakkvz0az4">
              Scegli il modello della tua prossima creazione
            </h2>
            <div className="mt-5 h-px w-16 bg-gold" aria-hidden="true" data-id="element-207" data-mp="2bhu0jobh83wz" />
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-ivory/85 max-w-lg" data-id="element-208" data-mp="2bfq1bjoivt31">
              Dopo i primi esercizi, esplora la raccolta di motivi e trova quello
              che ti ispira.
            </p>

            <dl className="mt-9 grid sm:grid-cols-2 gap-px rounded-2xl overflow-hidden bg-ivory/15" data-id="element-209" data-mp="1xhja2me2wrcc">
              <div className="bg-teal p-5" data-id="element-210" data-mp="1siyamp6niboy">
                <dt className="font-serif text-lg font-semibold" data-id="element-211" data-mp="1sk9d8lod1deh">I miei modelli da ricalcare</dt>
                <dd className="mt-1 text-sm leading-relaxed text-ivory/80" data-id="element-212" data-mp="3ruityrphs7pf">
                  Forme semplici per esercitarti a tracciare i contorni.
                </dd>
              </div>
              <div className="bg-teal p-5" data-id="element-213" data-mp="1l6ihx4snrr7p">
                <dt className="font-serif text-lg font-semibold" data-id="element-214" data-mp="1l5qlxsv5frgw">100+ modelli</dt>
                <dd className="mt-1 text-sm leading-relaxed text-ivory/80" data-id="element-215" data-mp="1pzl7l1ubegim">
                  Motivi più elaborati per le tue prossime creazioni.
                </dd>
              </div>
            </dl>

            <p className="mt-6 text-sm text-ivory/80" data-id="element-216" data-mp="1g6e2zj7ef4jl">
              Modelli da ricalcare, in aggiunta ai 6 progetti guidati di Le mie prime creazioni.
            </p>

            <a href="#offerta" className="mt-9 inline-flex w-full sm:w-auto justify-center whitespace-normal text-center rounded-full bg-ivory px-6 sm:px-8 py-4 text-base font-semibold text-teal hover:bg-sand transition-colors duration-200" data-id="element-217" data-mp="28vte08z2cxfi">
              Scopri il kit completo — {siteConfig.price}
            </a>
          </div>
        </div>

        {templateSamples.length > 0 && <ul className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-218" data-mp="nkb73d5rh2mw">
            {templateSamples.map(t => <li key={t.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-ivory" data-id="element-219" data-mp="fz8yuqsvvo0e">
                <img src={t.src} alt={t.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-220" data-mp="b1yzaibs5vyu" />
              </li>)}
          </ul>}
      </div>
    </section>;
}